import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import {
  downloadJitStock,
  getPartCoverage,
  sendComment,
  getJitLoadsByPiece,
  editTransit,
  getRemarkByPiece,
  createRemark,
  editRemark,
  downloadRemark,
  createTransit,
  downloadM100,
  getStockStatus
} from './async';
import { JitStockWithSimulation, PartCoverageDataState } from './types';
import { downloadXlsxFile } from 'modules/shared/services/downloadXlsxFile';
import { getColumnsFromLocalStorage } from 'modules/inbound/shared/utils/getColumnsFromLocalStorage';
import GetDateFormatedService from 'modules/inbound/shared/domain/GetDateFormatedService';
import { UserRole } from 'modules/shared/domain/UserRole';
import { NameValues } from 'modules/inbound/shared/domain/NameValues';
import { loadTransists } from 'modules/inbound/programCoverage/domain/TransitsData';
import format from 'date-fns/format';
import { parse } from 'date-fns';
import { LoadTransport } from 'modules/inbound/shared/domain/PlanningTransports';
import { CoverageStatus } from 'modules/inbound/shared/domain/CoverageStatusTypes';
import { AppState } from 'infrastructure/redux';

export const initialState: PartCoverageDataState = {
  data: {
    planningDates: [],
    stock: [],
    updatePlanningDate: '-',
    updateFisJit: '-',
    updateFismoon: '-',
    slateUpdate: '-'
  },
  columns: [],
  savedColumns: [],
  pagination: {
    page: 1,
    size: 50,
    pageCount: 0,
    totalCount: 0
  },
  requestStatus: '',
  selectedColumn: {
    key: '',
    isAscending: false
  },
  jitFile: null,
  downloadRequestStatus: '',
  isEditComment: false,
  editCommentResponse: null,
  editCommentRequestStatus: '',
  selectedPiece: '',
  selectedAction: null,
  // ----------------------
  // TRANSITS
  // ----------------------
  transitsRequestStatus: '',
  transits: { transits: { code: '', providerId: 0, loads: [], date: '' } },
  transitsPutRequestStatus: '',
  transitsDeleteRequestStatus: '',
  transitsEditable: {
    transits: { code: '', providerId: 0, loads: [], date: '' }
  },
  selectedTransits: [],
  transistError: [],
  createRemarkRequestStatus: '',
  createRemarkError: '',
  // ----------------------
  // REMARKS
  // ----------------------
  remarksRequestStatus: '',
  remarks: [],
  remarksPutRequestStatus: '',
  remarksDeleteRequestStatus: '',
  remarksEditable: null,
  remarksError: [],
  downloadRemaksRequestStatus: '',
  remarkFile: null,
  downloadM100RequestStatus: '',
  // ----------------------
  // STOCKSTATUS
  // ----------------------
  stockStatusRequestStatus: '',
  stockStatus: []
};

const PART_COVERAGE_COLUMNS_VIEW_STATE_KEY = 'PartCoverageColumnsView';

const TOTAL_COLUMNS_PROVIDER = 14;

const PartCoverageSlice = createSlice({
  name: 'PartCoverageProgramCoverage',
  initialState,
  reducers: {
    updateCurrentPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    updateSelectedColumn: (state, action) => {
      state.selectedColumn = action.payload;
    },
    updateColumnsList: (state, action) => {
      state.savedColumns = action.payload;
    },
    resetDownloadStatus: (state) => {
      state.downloadRequestStatus = initialState.downloadRequestStatus;
    },
    saveColumnsView: (state, action) => {
      localStorage.setItem(
        `${action.payload}-${PART_COVERAGE_COLUMNS_VIEW_STATE_KEY}`,
        JSON.stringify(state.savedColumns)
      );
    },
    loadColumnsView: (state, action) => {
      state.savedColumns = getColumnsFromLocalStorage({
        username: action.payload,
        localStorageKey: PART_COVERAGE_COLUMNS_VIEW_STATE_KEY,
        defaultColumns: [...state.columns]
      });
    },
    updateVisibleColumns: (state, action) => {
      state.savedColumns = state.savedColumns.map((item) =>
        item.key === action.payload.key
          ? { ...item, isVisibleCheck: !action.payload.isVisibleCheck }
          : item
      );
    },
    updateComment: (state, action) => {
      state.data.stock = state.data.stock.map((item) =>
        item.code === action.payload.code
          ? { ...item, comment: action.payload.comment }
          : item
      );
    },
    updateIsEditComment: (state, action) => {
      state.isEditComment = action.payload;
    },
    resetUpdateCommentStatus: (state) => {
      state.editCommentRequestStatus = initialState.editCommentRequestStatus;
      state.editCommentResponse = initialState.editCommentResponse;
    },

    updateSelectedPiece: (state, action) => {
      state.selectedPiece = action.payload;
    },
    updateSelectedAction: (state, action) => {
      state.selectedAction = action.payload;
    },
    editEditableTransits: (
      state,
      action: PayloadAction<{
        id: number;
        fieldName: keyof loadTransists;
        value: loadTransists[keyof loadTransists];
      }>
    ) => {
      state.transitsEditable.transits.loads =
        state.transitsEditable.transits.loads.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              [action.payload.fieldName]: action.payload.value
            };
          }
          return item;
        });
    },
    deleteEditableTransits: (state, action: PayloadAction<{ id: number }>) => {
      const filteredLoads = state.transitsEditable.transits.loads.filter(
        (item) => item.id !== action.payload.id
      );
      state.transitsEditable.transits.loads = filteredLoads;
      state.transits.transits.loads = filteredLoads;
    },
    updateTransits: (state, action: PayloadAction<{ id: number }>) => {
      const { id } = action.payload;

      const updatedLoad = state.transitsEditable.transits.loads.find(
        (item) => item.id === id
      );
      if (!updatedLoad) return;

      state.transits.transits.loads = state.transits.transits.loads.map(
        (item) => (item.id === id ? { ...updatedLoad } : item)
      );
    },
    updatePlanning: (
      state,
      action: PayloadAction<{
        code: string;
        providerTier: number;
        conType: string;
      }>
    ) => {
      const { code, providerTier, conType } = action.payload;
      const loadsTransitsEditable = state.transitsEditable.transits.loads;
      // 1.seleccionamos la pieza
      const stockItem = state.data.stock.find((item) => {
        return (
          item.code === code &&
          Number(item.T1Provider) === Number(providerTier) &&
          item.conType === conType
        );
      });
      if (!stockItem) {
        return;
      }
      // 2. recorremos el planning creando las nuevos loads
      type GroupedByDate = Record<string, LoadTransport[]>;
      const groupedLoads: GroupedByDate = loadsTransitsEditable.reduce(
        (acc, item) => {
          const date = parse(item.deliveryTimeDate, 'dd/MM/yyyy', new Date());
          const formattedDate = format(date, 'yyyy-MM-dd');

          if (!acc[formattedDate]) {
            acc[formattedDate] = [];
          }

          const NewItem = {
            providerId: state.transitsEditable.transits.providerId,
            plateNumber: item.plateNumber,
            deliveryTime: `${item.deliveryTimeDate} ${item.deliveryTime}`,
            amount: item.amount,
            providerDeliveryNote: item.providerDeliveryNote
          };
          acc[formattedDate].push(NewItem);

          return acc;
        },
        {} as GroupedByDate
      );
      // 3. Actualizamos los loads del palnning de la pieza
      Object.keys(stockItem.planning).forEach((date) => {
        stockItem.planning[date].loads =
          groupedLoads[date] && groupedLoads[date].length > 0
            ? groupedLoads[date]
            : [];
      });
    },
    simulateTransits: (
      state,
      action: PayloadAction<{
        loadids: number[];
        code: string;
        providerTier: number;
        conType: string;
      }>
    ) => {
      const { loadids, code, providerTier, conType } = action.payload;
      // 1. si loaids esta vacio eliminamos la simulacion
      if (!loadids || loadids.length === 0) {
        state.data.stock = state.data.stock.map((item) =>
          item.code === code &&
          Number(item.T1Provider) === Number(providerTier) &&
          item.conType === conType
            ? { ...item, simulatedJitStock: undefined }
            : item
        );
        return;
      }

      // 3. Crear copia profunda del stockItem
      const stockItem = state.data.stock.find(
        (item) =>
          item.code === code &&
          Number(item.T1Provider) === Number(providerTier) &&
          item.conType === conType
      );
      if (!stockItem) return;

      const newStockWithSimulation: JitStockWithSimulation = {
        ...stockItem,
        planning: structuredClone(current(stockItem.planning))
      };

      // 2. calculamos quantityStock simulado
      const loadsTransits = state.transits.transits.loads;
      let simulatedQuantityStock = Number.parseInt(
        newStockWithSimulation.quantityStock
      );

      loadsTransits.forEach((load) => {
        if (loadids.includes(load.id)) {
          simulatedQuantityStock += load.amount;
        }
      });

      // 5. Recorrer planning y aplicar simulación
      let remainingQuantity = simulatedQuantityStock;
      Object.entries(newStockWithSimulation.planning).forEach(
        ([, planningItem]) => {
          if (remainingQuantity <= 0) return;

          const segment = planningItem?.coverageSegments?.[0];
          if (!segment) return;

          const planningAmount = planningItem.amount ?? 0;

          if (remainingQuantity - planningAmount > 0) {
            segment.status = CoverageStatus.COVERED;
          } else {
            segment.status = 'CRITICAL';
          }

          remainingQuantity -= planningAmount;
        }
      );

      // 6. Actualizar el stock simulado
      if (
        !Number.isNaN(+newStockWithSimulation.quantityStock) &&
        newStockWithSimulation.quantityStock !== ''
      ) {
        newStockWithSimulation.quantityStock =
          simulatedQuantityStock.toString();
        newStockWithSimulation.coverageStoppedAt = '-';
        newStockWithSimulation.lineStoppedAt = '-';
      }
      // 7. Actualizamos data para que se renderice los componetes de la tabla de piezas.
      const newStock = state.data.stock.map((item) =>
        item.code === code &&
        Number(item.T1Provider) === Number(providerTier) &&
        item.conType === conType
          ? { ...item, simulatedJitStock: newStockWithSimulation }
          : item
      );
      state.data = {
        ...state.data,
        stock: newStock
      };
    },
    toggleTransitSelected: (state, action: PayloadAction<number>) => {
      const id = action.payload;

      if (state.selectedTransits.includes(id)) {
        state.selectedTransits = state.selectedTransits.filter(
          (itemId) => itemId !== id
        );
      } else {
        state.selectedTransits.push(id);
      }
    },

    clearSelectedTransits: (state) => {
      state.selectedTransits = [];
    },

    showTransistError: (
      state,
      action: PayloadAction<{ error: string; columnKey: string; id: number }>
    ) => {
      const { error, columnKey, id } = action.payload;

      const index = state.transistError.findIndex(
        (item) => item.columnKey === columnKey && item.id === id
      );
      const newsTransistError = structuredClone(current(state.transistError));
      if (index === -1) {
        newsTransistError.push({ error, columnKey, id });
      } else {
        newsTransistError[index].error = error;
      }
      state.transistError = newsTransistError;
    },
    deleteTransistError: (
      state,
      action: PayloadAction<{ columnKey: string; id: number }>
    ) => {
      const { columnKey, id } = action.payload;
      state.transistError = state.transistError.filter(
        (item) => !(item.columnKey === columnKey && item.id === id)
      );
    },
    deleteRemarck: (
      state,
      action: PayloadAction<{
        id: number;
        code: string;
        providerTier: number;
        conType: string;
      }>
    ) => {
      const { id, code, providerTier, conType } = action.payload;
      const newNemark = state.remarks.filter((item) => item.id !== id);
      if (newNemark.length === 0) {
        state.data.stock = state.data.stock.map((item) => {
          if (
            item.code === code &&
            Number(item.T1Provider) === Number(providerTier) &&
            item.conType === conType
          ) {
            item.hasRemark = false;
          }
          return item;
        });
      }
      state.remarks = newNemark;
    },
    resetDownloadRemarkStatus: (state) => {
      state.downloadRemaksRequestStatus =
        initialState.downloadRemaksRequestStatus;
    },
    setLoadHasRemark: (
      state,
      action: PayloadAction<{
        code: string;
        provider_id: number;
        provider_tier: string;
        has: boolean;
      }>
    ) => {
      const { code, provider_id, provider_tier, has } = action.payload;
      state.data.stock = state.data.stock.map((item) => {
        if (
          item.code === code &&
          Number(item.T1Provider) === provider_id &&
          item.conType === provider_tier
        ) {
          item.hasRemark = has;
        }
        return item;
      });
    },
    resetCreateRemarkError: (state) => {
      state.createRemarkError = null;
    },
    resetM100DownloadStatus: (state) => {
      state.downloadM100RequestStatus = initialState.downloadM100RequestStatus;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getPartCoverage.fulfilled, (state, action) => {
      state.data.planningDates = action.payload.planningDates;
      state.data.stock = action.payload.stock;
      state.columns = action.payload.columns || [];
      state.data.updatePlanningDate = action.payload.updatePlanning;
      state.pagination = action.payload.pagination;
      state.requestStatus = action.meta.requestStatus;
      state.data.updateFisJit = action.payload.updateFisJit;
      state.data.updateFismoon = action.payload.updateFismoon;
      state.data.slateUpdate = action.payload.slateUpdate;
    });
    builder.addCase(getPartCoverage.pending, (state, action) => {
      state.requestStatus = action.meta.requestStatus;
    });
    builder.addCase(getPartCoverage.rejected, (state, action) => {
      state.requestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadJitStock.fulfilled, (state, action) => {
      state.jitFile = action.payload;
      downloadXlsxFile({
        file: action.payload,
        fileName: `P_Jit_Part_Coverage_${GetDateFormatedService.formatCompleteISODate()}`
      });
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadJitStock.pending, (state, action) => {
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadJitStock.rejected, (state, action) => {
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(sendComment.fulfilled, (state, action) => {
      state.editCommentRequestStatus = action.meta.requestStatus;
      state.editCommentResponse = action.payload;
    });
    builder.addCase(sendComment.pending, (state, action) => {
      state.editCommentRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(sendComment.rejected, (state, action) => {
      state.editCommentRequestStatus = action.meta.requestStatus;
    });
    /*manage getJitLoadsByPiece trunk*/
    builder.addCase(getJitLoadsByPiece.fulfilled, (state, action) => {
      state.transitsRequestStatus = action.meta.requestStatus;
      state.transits = action.payload;
      state.transitsEditable = structuredClone(action.payload);
    });
    builder.addCase(getJitLoadsByPiece.pending, (state, action) => {
      state.transitsRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getJitLoadsByPiece.rejected, (state, action) => {
      state.transitsRequestStatus = action.meta.requestStatus;
    });
    /*manage createTransit trunk*/
    builder.addCase(createTransit.fulfilled, (state, action) => {
      state.createRemarkRequestStatus = action.meta.requestStatus;
      /**state.transits.transits.loads.push(action.payload);
      state.transitsEditable.transits.loads.push(action.payload);*/
      state.transits = {
        ...state.transits,
        transits: {
          ...state.transits.transits,
          loads: [...state.transits.transits.loads, action.payload]
        }
      };

      state.transitsEditable = {
        ...state.transitsEditable,
        transits: {
          ...state.transitsEditable.transits,
          loads: [...state.transitsEditable.transits.loads, action.payload]
        }
      };
    });
    builder.addCase(createTransit.pending, (state, action) => {
      state.createRemarkRequestStatus = action.meta.requestStatus;
      state.createRemarkError = null;
    });
    builder.addCase(createTransit.rejected, (state, action) => {
      state.createRemarkError = action.payload ?? action.error.message ?? null;
      state.createRemarkRequestStatus = action.meta.requestStatus;
    });
    /*manage editTransit trunk*/
    builder.addCase(editTransit.fulfilled, (state, action) => {
      state.transitsPutRequestStatus = action.meta.requestStatus;
      state.transits = {
        ...state.transits,
        transits: {
          ...state.transits.transits,
          loads: state.transitsEditable.transits.loads.map((item) => {
            return item.id === action.payload.id ? action.payload : item;
          })
        }
      };

      state.transitsEditable = {
        ...state.transitsEditable,
        transits: {
          ...state.transitsEditable.transits,
          loads: state.transits.transits.loads.map((item) => {
            return item.id === action.payload.id ? action.payload : item;
          })
        }
      };
    });
    builder.addCase(editTransit.pending, (state, action) => {
      state.transitsPutRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(editTransit.rejected, (state, action) => {
      state.transitsPutRequestStatus = action.meta.requestStatus;
    });
    /*manage getRemarkByPiece trunk*/
    builder.addCase(getRemarkByPiece.fulfilled, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
      state.remarks = action.payload;
    });
    builder.addCase(getRemarkByPiece.pending, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getRemarkByPiece.rejected, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    /*manage createRemark trunk*/
    builder.addCase(createRemark.fulfilled, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
      state.remarks.push(action.payload);
    });
    builder.addCase(createRemark.pending, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(createRemark.rejected, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    /*manage editRemark trunk*/
    builder.addCase(editRemark.fulfilled, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;

      state.remarks = state.remarks.map((remark) =>
        remark.id === action.payload.id ? action.payload : remark
      );
    });
    builder.addCase(editRemark.pending, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(editRemark.rejected, (state, action) => {
      state.remarksRequestStatus = action.meta.requestStatus;
    });
    /*manage downloadRemark trunk*/
    builder.addCase(downloadRemark.fulfilled, (state, action) => {
      state.remarkFile = action.payload;
      downloadXlsxFile({
        file: action.payload,
        fileName: `Remark_${GetDateFormatedService.formatCompleteISODate()}`,
        extension: 'pdf'
      });
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadRemark.pending, (state, action) => {
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadRemark.rejected, (state, action) => {
      state.downloadRequestStatus = action.meta.requestStatus;
    });
    /*M100 dowload*/
    builder.addCase(downloadM100.fulfilled, (state, action) => {
      state.remarkFile = action.payload;
      downloadXlsxFile({
        file: action.payload,
        fileName: `Remark_${GetDateFormatedService.formatCompleteISODate()}`,
        extension: 'xlsx'
      });
      state.downloadM100RequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadM100.pending, (state, action) => {
      state.downloadM100RequestStatus = action.meta.requestStatus;
    });
    builder.addCase(downloadM100.rejected, (state, action) => {
      state.downloadM100RequestStatus = action.meta.requestStatus;
    });
    /*manage getStockStatus trunk*/
    builder.addCase(getStockStatus.fulfilled, (state, action) => {
      state.stockStatusRequestStatus = action.meta.requestStatus;
      state.stockStatus = action.payload;
    });
    builder.addCase(getStockStatus.pending, (state, action) => {
      state.stockStatusRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getStockStatus.rejected, (state, action) => {
      state.stockStatusRequestStatus = action.meta.requestStatus;
    });
  }
});

export const getJitDataState = (state) =>
  state.partCoverageStateProgramCoverage.data;
export const getJitstockState = (state) => {
  const stateSelected: PartCoverageDataState =
    state.partCoverageStateProgramCoverage;
  return stateSelected.data.stock;
};
export const getColumns = (state) =>
  state.partCoverageStateProgramCoverage.savedColumns;
export const getUserInboundInfo = (state) =>
  state.userInboundState.userInboundData;
export const getCheckListColumns = (state) => {
  const columns = getColumns(state);
  const { role } = getUserInboundInfo(state);
  if (columns.length) {
    if (
      role === UserRole.INBOUND_SEAT ||
      role === UserRole.INBOUND_SUPER_ADMIN
    ) {
      return columns;
    }
    const providerColumns = columns
      .filter((item) => item.key !== NameValues.COMMENT)
      .slice(0, TOTAL_COLUMNS_PROVIDER);
    return providerColumns;
  }
  return [];
};
export const getisLoadingStatus = (state) =>
  state.partCoverageStateProgramCoverage.requestStatus === 'pending';
export const getHasError = (state) =>
  state.partCoverageStateProgramCoverage.requestStatus === 'rejected';
export const getCurrentPage = (state) =>
  state.partCoverageStateProgramCoverage.pagination.page;
export const getResultsPerPage = (state) =>
  state.partCoverageStateProgramCoverage.pagination.size;
export const getSelectedColumn = (state) =>
  state.partCoverageStateProgramCoverage.selectedColumn;
export const getTotalPages = (state) =>
  state.partCoverageStateProgramCoverage.pagination.pageCount;
export const getTotalCount = (state) =>
  state.partCoverageStateProgramCoverage.pagination.totalCount;
export const getDownloadJitStockSuccessful = (state) =>
  state.partCoverageStateProgramCoverage.downloadRequestStatus ===
    'fulfilled' && state.partCoverageStateProgramCoverage.jitFile !== null;
export const getDownloadJitStockError = (state) =>
  state.partCoverageStateProgramCoverage.downloadRequestStatus === 'rejected';
export const getDownloadJitStockIsPending = (state) =>
  state.partCoverageStateProgramCoverage.downloadRequestStatus === 'pending';
export const getEditCommentSuccess = (state) =>
  state.partCoverageStateProgramCoverage.editCommentRequestStatus ===
    'fulfilled' &&
  state.partCoverageStateProgramCoverage.editCommentResponse !== null;
export const getEditCommentFailed = (state) =>
  (state.partCoverageStateProgramCoverage.editCommentRequestStatus ===
    'fulfilled' &&
    state.partCoverageStateProgramCoverage.editCommentResponse === null) ||
  state.partCoverageStateProgramCoverage.editCommentRequestStatus ===
    'rejected';
export const getIsEditComment = (state) =>
  state.partCoverageStateProgramCoverage.isEditComment;
export const getSelectedPiece = (state) => {
  return state.partCoverageStateProgramCoverage.selectedPiece.split('-')[0];
};
export const getSelectedProviderTier = (state) => {
  return state.partCoverageStateProgramCoverage.selectedPiece.split('-')[1];
};
export const getSelectedConType = (state) => {
  const selectedPiece =
    state.partCoverageStateProgramCoverage.selectedPiece.split('-');
  return `${selectedPiece[2]}-${selectedPiece[3]}`;
};
export const getSelectedPieceId = (state) => {
  return state.partCoverageStateProgramCoverage.selectedPiece;
};

// ----------------------
// TRANSITS
// ----------------------
export const getTransits = (state) => {
  return state.partCoverageStateProgramCoverage.transits;
};
export const getTransitsEditable = (state) => {
  return state.partCoverageStateProgramCoverage.transitsEditable;
};
export const getTransitsEditableById = (state, id) => {
  const transits =
    state.partCoverageStateProgramCoverage.transitsEditable.transits;

  if (transits?.loads) {
    return (
      (transits.loads.find((load) => load.id === id) as loadTransists) || null
    );
  }

  return null;
};
export const getTransitsSuccess = (state) =>
  state.partCoverageStateProgramCoverage.transitsRequestStatus === 'fulfilled';
export const getTransitsFailed = (state) =>
  state.partCoverageStateProgramCoverage.transitsRequestStatus === 'rejected';
export const putTransitsSuccess = (state) =>
  state.partCoverageStateProgramCoverage.transitsPutRequestStatus ===
  'fulfilled';
export const putTransitsFailed = (state) =>
  state.partCoverageStateProgramCoverage.transitsPutRequestStatus ===
  'rejected';
export const getSelectedTransits = (state) =>
  state.partCoverageStateProgramCoverage.selectedTransits;
export const getSimulationExecuted =
  ({
    code,
    provider_id,
    provider_tier
  }: {
    code: string;
    provider_id: number;
    provider_tier: string;
  }) =>
  (state) => {
    const stateLocal: PartCoverageDataState =
      state.partCoverageStateProgramCoverage;

    const piece = stateLocal.data.stock.find(
      (item) =>
        item.code === code &&
        Number(item.T1Provider) === provider_id &&
        item.conType === provider_tier
    );
    return piece?.simulatedJitStock !== undefined;
  };
export const showTransistErrorText = (state) =>
  state.partCoverageStateProgramCoverage.transistError;

export const createRemarkError = (state) =>
  state.partCoverageStateProgramCoverage.createRemarkError;

// ----------------------
// REMARKS
// ----------------------
export const getRemarks = (state: AppState) => {
  return state.partCoverageStateProgramCoverage.remarks;
};

export const getRemarksEditable = (state: AppState) => {
  return state.partCoverageStateProgramCoverage.remarksEditable;
};

export const getRemarksEditableById = (id: number) => (state: AppState) => {
  const remarks = state.partCoverageStateProgramCoverage.remarks;

  return remarks.find((item) => item.id === id) || null;
};

export const getRemarksSuccess = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksRequestStatus === 'fulfilled';

export const getRemarksFailed = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksRequestStatus === 'rejected';

export const putRemarksSuccess = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksPutRequestStatus ===
  'fulfilled';

export const putRemarksFailed = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksPutRequestStatus === 'rejected';

export const deleteRemarksSuccess = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksDeleteRequestStatus ===
  'fulfilled';

export const deleteRemarksFailed = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksDeleteRequestStatus ===
  'rejected';

export const showRemarksErrorText = (state: AppState) =>
  state.partCoverageStateProgramCoverage.remarksError;

export const getSelectedAction = (state: AppState) =>
  state.partCoverageStateProgramCoverage.selectedAction;

export const getPieceByCode = (code: string) => (state: AppState) => {
  return state.partCoverageStateProgramCoverage.data.stock.find(
    (item) => item.code === code
  );
};

export const getPieceBySelectedPiece = (state: AppState) => {
  const splitSelectedPiece =
    state.partCoverageStateProgramCoverage.selectedPiece.split('-');
  const code = splitSelectedPiece[0];
  const providerId = splitSelectedPiece[1];
  const providerTier = `${splitSelectedPiece[2]}-${splitSelectedPiece[3]}`;
  return state.partCoverageStateProgramCoverage.data.stock.find(
    (item) =>
      item.code === code &&
      item.T1Provider === providerId &&
      item.conType === providerTier
  );
};
export const getDownloadRemarkSuccessful = (state) =>
  state.partCoverageStateProgramCoverage.downloadRemaksRequestStatus ===
    'fulfilled' && state.partCoverageStateProgramCoverage.jitFile !== null;
export const getDownloadRemarkError = (state) =>
  state.partCoverageStateProgramCoverage.downloadRemaksRequestStatus ===
  'rejected';
export const getDownloadRemarkIsPending = (state) =>
  state.partCoverageStateProgramCoverage.downloadRemaksRequestStatus ===
  'pending';

export const getDownloadM100Pending = (state) =>
  state.partCoverageStateProgramCoverage.downloadM100RequestStatus ===
  'pending';
export const getDownloadM100Successful = (state) =>
  state.partCoverageStateProgramCoverage.downloadM100RequestStatus ===
    'fulfilled' && state.partCoverageStateProgramCoverage.jitFile !== null;
export const gdownloadM100StatusError = (state) =>
  state.partCoverageStateProgramCoverage.downloadM100RequestStatus ===
  'rejected';
export const getStockStatusData = (state: AppState) => {
  return state.partCoverageStateProgramCoverage.stockStatus;
};
export const getStockStatusPending = (state) =>
  state.partCoverageStateProgramCoverage.stockStatusRequestStatus === 'pending';
export const getStockStatusSuccessful = (state) =>
  state.partCoverageStateProgramCoverage.stockStatusRequestStatus ===
  'fulfilled';
export const getStockStatusStatusError = (state) =>
  state.partCoverageStateProgramCoverage.stockStatusRequestStatus ===
  'rejected';

export const {
  updateCurrentPage,
  updateSelectedColumn,
  updateIsEditComment,
  updateComment,
  resetUpdateCommentStatus,
  updateColumnsList,
  resetDownloadStatus,
  updateVisibleColumns,
  saveColumnsView,
  loadColumnsView,
  updateSelectedPiece,
  editEditableTransits,
  updateTransits,
  updateSelectedAction,
  deleteEditableTransits,
  updatePlanning,
  simulateTransits,
  toggleTransitSelected,
  clearSelectedTransits,
  showTransistError,
  deleteTransistError,
  deleteRemarck,
  resetDownloadRemarkStatus,
  resetCreateRemarkError,
  setLoadHasRemark,
  resetM100DownloadStatus
} = PartCoverageSlice.actions;

export default PartCoverageSlice.reducer;
